import { type OpenAPIV3 } from 'openapi-types';

export const AppVariable: OpenAPIV3.NonArraySchemaObject = {
  type: 'object',
  description: 'App variable',
  required: ['name'],
  additionalProperties: false,
  properties: {
    id: {
      type: 'number',
      description: 'An autogenerated ID.',
      readOnly: true,
    },
    name: {
      type: 'string',
      description: 'The name of the variable, that will be accessible from clients.',
    },
    value: {
      description: 'The value of the variable.',
      anyOf: [{ type: 'string' }, { type: 'boolean' }, { type: 'number' }],
    },
  },
};
